import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/tracking/reports')({
  component: () => <PageStub title="Unified Reporting" description="Business reports and analytics" />,
});
